import { push } from 'react-router-redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types } from '@actions/transcript';
import {
  createMediaFile,
  validateTranscript,
  uploadFile,
  upsertTranscript,
} from '@services/conferenceResource';
import { tokenSelector } from '@selectors/authentication';
import { selectTranscript, selectPeople, selectCallAudio } from '@selectors/transcript';
import { cleanConferences } from '@actions/conferences';
import { cleanTranscripts } from '@actions/transcripts';
import { getFileNames } from '@services/transcriptManager';

export function* fileSaga(token) {
  const audioCall = yield select(selectCallAudio);
  const uploadResponse = yield call(uploadFile, [audioCall], token);
  return getFileNames(uploadResponse.data.result.files);
}

export function* transcriptUpsertSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const conference = yield select(selectTranscript);
    validateTranscript(conference);
    // Uploading files to external store.
    const fileNames = yield call(fileSaga, token);
    // Upserting conference.
    const people = yield select(selectPeople);
    const transcriptResponse = yield call(
      upsertTranscript,
      conference,
      people,
      fileNames,
      token,
    );
    // Sending request to transcription service.
    const conferenceId = transcriptResponse.data.transcript.id;
    yield call(createMediaFile, conferenceId, token);
    yield put({
      type: types.INSERT.SUCCESS,
      message: 'Successfully created transcript.',
    });
    yield put(cleanConferences());
    yield put(cleanTranscripts());
    yield put(push('/transcripts'));
  } catch (err) {
    yield put({
      type: types.INSERT.FAILURE,
      message: err.message || 'Error when creating the transcript.',
      errors: err.errors,
    });
  }
}

export default function* transcriptUpsert() {
  yield takeEvery(types.INSERT.STARTED, transcriptUpsertSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcript/insert.js